// extracted by mini-css-extract-plugin
export default {"dialog":"MakePaymentDialog_dialog__UVU-e","error":"MakePaymentDialog_error__owAmD","formButton":"MakePaymentDialog_formButton__cuq0v"};